// Static data base. The site no longer talks to a backend — all content is
// served from snapshot JSON files under public/data/ (see scripts/snapshot_api.py
// to refresh the snapshot from the old API).
export const Global =
{
    Url:"/data"
}
